import { useState, useEffect, useMemo} from 'react';
import { Typography, Paper, Button, Stack, Badge } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../config/axiosConfig';
import MiTabla from '../../components/plantilla/tabla/MiTabla';
import { green, red } from '@mui/material/colors';
import BtnAcciones from '../../components/plantilla/tabla/BtnAcciones';
import GalleryDialog from './modales/GalleryDialog';
import QrDialog from './modales/QrDialog';
import DetalleDialog from './modales/DetalleDialog';
import Swal from 'sweetalert2';

import Navbar from '../../components/Navbar';

import { Tabs, Tab } from '@mui/material';

// Iconos
import CollectionsIcon from '@mui/icons-material/Collections';
import QrCodeIcon from '@mui/icons-material/QrCode';
import TireRepairSharpIcon from '@mui/icons-material/TireRepairSharp';

const Dashboard = () => {

    const [data, setData] = useState([]);
    const [openGallery, setOpenGallery] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [openQrDialog, setOpenQrDialog] = useState(false);
    const [qrText, setQrText] = useState('');

    const [openDetalleDialog, setOpenDetalleDialog] = useState(false);
    const [unidadIdSeleccionada, setUnidadIdSeleccionada] = useState(null);

    const [statusFilter, setStatusFilter] = useState('ALL');

    /*=============================================
    Funcion para abrir el dialogo de detalle
    =============================================*/

    const mostrarModalDetalle = (row) => 
    {
        if (!row.unidad) {
            Swal.fire("Error", "Unidad sin ID válido.", "error");
            return;
        }

        setUnidadIdSeleccionada(row.unidad);
        setOpenDetalleDialog(true);
    };

    /*=============================================
    Funcion para abrir el dialogo de qrs
    =============================================*/
    const mostrarModalQR = (row) => 
    {
        if (row.qr) {
            setQrText(row.qr);
            setOpenQrDialog(true);
        } else {
            Swal.fire("Sin QR", "Esta unidad no tiene QR asignado.", "info");
        }
    };

    /*=============================================
    Funcion que renderiza el dialogo de galeria
    =============================================*/
    const renderizarDialogGaleria = (row) => 
    {
        let rutas = [];
    
        try {
            rutas = JSON.parse(row.rutas_fotos); 
        } catch (e) {
            console.warn("No se pudo convertir rutas_fotos a array:", e);
        }
    
        if (Array.isArray(rutas) && rutas.length > 0) {
            setSelectedRow({ ...row, rutas_fotos: rutas });
            setOpenGallery(true);
        } else {
            Swal.fire("Sin imágenes", "Esta unidad no tiene imágenes disponibles.", "info");
        }
    };    

    /*=============================================
    Funcion que cierra el dialogo de galeria
    =============================================*/
    const handleCloseGallery = () => 
    {
        setOpenGallery(false);
        setSelectedRow(null);
    };

    const formatDate = (date) => {
        const options = {
            year: '2-digit', // Año con dos dígitos
            month: '2-digit', // Mes con dos dígitos
            day: '2-digit', // Día con dos dígitos
            hour: '2-digit', // Hora con dos dígitos
            minute: '2-digit', // Minutos con dos dígitos
            hour12: false, // Formato de 24 horas
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
    
        // Formato deseado: MM/DD/YY HH:mm
        const [datePart, timePart] = formattedDate.split(', '); // Separar fecha y hora
        const [month, day, year] = datePart.split('/'); // Separar mes, día y año
        const formattedDateTime = `${month}/${day}/${year} ${timePart.slice(0, 5)}`; // Construir el formato
    
        return formattedDateTime;
    };

    const columns = [
        {
            field: 'unidad', headerName: 'UNIDAD',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'qr',
            headerName: 'QR ASIGNADO',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                if (!params.value) {
                return null; // No renderiza nada si qr es null, undefined o vacío
                }

                return (
                <BtnAcciones
                    icon={<QrCodeIcon />}
                    label="Ver QR"
                    onClick={() => mostrarModalQR(params.row)}
                />
                );
            }
        },
        { field: 'tipo', headerName: 'TIPO',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "rutas_fotos",
            headerName: "IMÁGENES",
            filterable: false,
            width: 100,
            renderCell: (params) => {
                if (!params.row.rutas_fotos) {
                    return []; 
                }
                
                return [
                    <BtnAcciones
                    key="ver-imagenes"
                    icon={<CollectionsIcon />}
                    label="Ver Imágenes"
                    onClick={() => renderizarDialogGaleria(params.row)}
                    />
                ];
            }
        },
        {
            field: "detalle_llanta",
            headerName: "DETALLES DE LA LLANTA",
            filterable: false,
            width: 100,
            renderCell: (params) => 
            {
                // Suponiendo que el campo a checar es 'detallesLlanta'
                if (!params.row.detalle_llanta) {
                // Si no hay detalles, no mostrar botón
                return [];
                }

                return [
                <BtnAcciones
                    key="ver-detalles"
                    icon={<TireRepairSharpIcon />}
                    label="Ver Detalles"
                    onClick={() => mostrarModalDetalle(params.row)}
                />
                ];
            }
        },
        {
            field: 'usuario', headerName: 'USUARIO',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'fecha', headerName: 'FECHA DE ALTA',
            flex: 1,
            headerAlign: "center",
            align: "center",
             renderCell: (params) => {
                if (!params.value) {
                return ""; // No mostrar nada si fecha es null o undefined
                }
                return formatDate(params.value);
            }
        },
        {
            field: 'unidad_id', headerName: 'DADO DE ALTA',
            flex: 1,
            headerAlign: "center",
            align: "center",
             renderCell: (params) => {
                if (!params.value) {
                return "NO"; 
                }
                return "SI";
            }
        },

    ];

    const fetchData = async () => {
        try {
            const response = await myApi.get('/alta_unidad/getDashboard');
            console.log(response.data.data);
            setData(response.data.data);
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const handleRowClick = (params) => {

    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (selectedRow) {
            console.log("Galería abierta con:", selectedRow.rutas_fotos);
        }
    }, [selectedRow]);

    // =============================================
    // Actualiza estatus de unidades
    // =============================================
    const actualizarEstatusUnidades = async () => 
    {
        Swal.fire({
            title: 'Actualizando...',
            text: 'Por favor espera mientras se actualizan los estatus de las unidades.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        try 
        {
            const response = await fetch('https://apigeneral.ebtapps.com/general/api/fleetrock/getAllUnits');
            if (!response.ok) throw new Error('Error en la petición');
            const result = await response.json();

            Swal.fire({
                icon: 'success',
                title: 'Estatus actualizado',
                //text: `Se procesaron ${result?.data?.length || 0} unidades correctamente.`,
            });

            // Después de actualizar los estatus, recargamos el dashboard
            fetchData();
        } 
        catch (error) 
        {
            console.error('Error actualizando estatus:', error);
            Swal.fire('Error', 'No se pudo actualizar el estatus de las unidades.', 'error');
        }
    };

    // =============================================
    // Actualización automática cada 5 minutos
    // =============================================
    useEffect(() => {
        fetchData(); // Primera carga
        const interval = setInterval(fetchData, 5 * 60 * 1000); // 5 minutos
        return () => clearInterval(interval);
    }, []);

/*  const totalCount = data.length;
    const altaCount = data.filter(row => row.unidad_id !== null).length;
    const faltantesCount = data.filter(row => row.unidad_id === null).length; */

    const { totalCount, altaCount, faltantesCount } = useMemo(() => 
    {
        const total = data.length;
        const alta = data.filter(r => r.unidad_id !== null).length;
        const faltantes = total - alta;
        return { totalCount: total, altaCount: alta, faltantesCount: faltantes };
    }, [data]);

    return (
        <>
        <Navbar />
        <Paper sx={{padding: 2}}>
            <Grid size={12} marginBottom={2}>
                <Tabs
                    value={statusFilter}
                    onChange={(e, newValue) => setStatusFilter(newValue)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="standard"
                >
                    <Tab
                        label={
                            <Badge color="primary" badgeContent={totalCount} max={Infinity}>
                                TODOS
                            </Badge>
                        }
                        value="ALL"
                    />
                    <Tab
                        label={
                            <Badge color="success" badgeContent={altaCount} max={Infinity}>
                                DADOS DE ALTA
                            </Badge>
                        }
                        value="SI"
                    />
                    <Tab
                        label={
                            <Badge color="error" badgeContent={faltantesCount} max={Infinity}>
                                FALTANTES
                            </Badge>
                        }
                        value="NO"
                    />
                </Tabs>
                
            </Grid>
            <Grid container>
                <Grid size={{ xs: 12, md: 8 }}>
                    <Typography variant="h4" fontWeight="bold" marginBottom={2}>
                        Dashboard Alta de Unidades - QR
                    </Typography>

                    {/* BOTONES DE ACCIÓN */}
{/*                     <Stack direction="row" spacing={2}>
                        <Button
                        variant="contained"
                        color="primary"
                        onClick={fetchData}
                        >
                        Actualizar
                        </Button>

                        <Button
                        variant="contained"
                        color="secondary"
                        onClick={actualizarEstatusUnidades}
                        >
                        Actualizar Estatus de Unidades
                        </Button>
                    </Stack> */}
                </Grid>

                {/** {LISTA DE UNIDADES} */}
                <Grid size={12}
                    marginTop={1}>
                    <MiTabla
                        columns={columns}
                        data={
                            data.filter((row) => 
                            {
                                if (statusFilter === 'SI') 
                                {
                                    return row.unidad_id !== null;
                                } 
                                else if (statusFilter === 'NO') 
                                {
                                    return row.unidad_id === null;
                                }
                                return true; // 'ALL'
                            })
                        }
                        rowClick={handleRowClick}
                    />
                </Grid>
            </Grid>
        </Paper>
        {selectedRow && (
            <GalleryDialog
                open={openGallery}
                onClose={handleCloseGallery}
                fotos={selectedRow?.rutas_fotos || []}
            />
        )}
        <QrDialog
            open={openQrDialog}
            onClose={() => setOpenQrDialog(false)}
            qrText={qrText}
        />
        <DetalleDialog
            open={openDetalleDialog}
            onClose={() => setOpenDetalleDialog(false)}
            unidadId={unidadIdSeleccionada}
        />
        </>
    )
}

export default Dashboard